import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { User } from 'src/models/user.model';
import { AuthService } from 'src/services/auth/auth.service';
import { CompanyService } from 'src/services/company/company.service';
import { CryptoService } from 'src/services/crypto/crypto.service';
import { UserService } from 'src/services/user/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-company-login',
  templateUrl: './company-login.component.html',
  styleUrls: ['./company-login.component.scss']
})
export class CompanyLoginComponent implements OnInit {
  form: FormGroup;
  loading: boolean;
  returnUrl: string;

  constructor(
      private fb: FormBuilder,
      private recaptchaV3Service: ReCaptchaV3Service,
      private router: Router,
      private route: ActivatedRoute,
      private companyService: CompanyService,
      private meta: Meta,
      private cryptoService: CryptoService
  ) { }

  ngOnInit(): void {
      this.returnUrl = this.route.snapshot.params.next;
      
      this.meta.addTag({ name: 'description', content: "Se connecter" });
      this.meta.addTag({ name: 'keywords', content: 'BSTP Guinée, BSTP, bstpgn, ' });
      this.meta.addTag({ name: 'author', content: 'BSTP Guinée' });

      this.form = this.fb.group({
          email: this.fb.control(null, [Validators.required]),
          recaptcha: this.fb.control(null, [Validators.required]),
      });

      if (this.companyService.isAuthenticated()) {
        
          const returnUrl = "company/dashboard";

          window.location.replace(returnUrl);
      }
  }

  onSubmit() {
      if (this.form.invalid) {
          for (const control of Object.keys(this.form.controls)) {
              this.form.controls[control].markAsTouched();
          }
          return;
      }

      this.recaptchaV3Service
          .execute("importantAction")
          .subscribe((token: string) => {
              console.debug(`Token [${token}] generated`);
          });

      this.loading = true;
      this.companyService.login(this.form.value).subscribe({
          next: (data: any) => {
              this.loading = false;
              localStorage.setItem("email", this.form.value.email);
              this.router.navigate(['/code-confirmation'])
          },
          error: (error) => {
              console.error(error);
              this.loading = false;
              Swal.fire({
                  title: "Authentification",
                  html: error.error.detail,
                  icon: "error",
                  showCancelButton: false,
                  confirmButtonColor: '#006481',
                  color: '#006481',
                  iconColor: '#e40e20',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'FERMER',
              });
          },
      });
  }
}
